module.exports = __webpack_public_path__ + "static/media/Reinaldo-Simizu.2c7a23b4.jpg";